import { motion } from "framer-motion";

/* Reusable scroll-reveal wrapper */
export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children, testid }) => (
  <div
    data-testid={testid}
    className="inline-flex items-center gap-3 text-xs md:text-sm uppercase tracking-[0.28em] font-semibold text-[#1E6BFF] mb-6"
  >
    <span className="h-px w-8 bg-[#1E6BFF]" />
    {children}
  </div>
);
